var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FilterData } from 'path-shared/models/filter-data';
var AparellTipusFilter = /** @class */ (function (_super) {
    __extends(AparellTipusFilter, _super);
    function AparellTipusFilter(sortField, sortDir) {
        var _this = _super.call(this, sortField, sortDir) || this;
        _this.id = null;
        _this.codiTipus = '';
        _this.descTipus = '';
        _this.numLocalitzacions = null;
        return _this;
    }
    return AparellTipusFilter;
}(FilterData));
export { AparellTipusFilter };
